import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { useUserActions } from 'shared/auth/hooks/useUserActions';
import { FeedbackStatus } from '../../api';
import ReportStatus from 'shared/components/Feedback/ReportStatus';
import RenderOrganizationLogo from './RenderOrganizationLogo';
import PoweredByLogo from 'npo/pages/ReportBuilder/Components/PoweredByLogo';

interface Account {
  ein: string; // '000000000'
  id: string; // '11521'
  logoFile: string;
  missionStatement: string;
  name: string;
  numberOfWomen: number | null;
  numberOfpeopleOfColor: number | null;
  officeLocation: string; // 'Edmonton, AB, Canada'
  personOfColor: null;
  totalNumber: number;
  type: 'grantee' | 'funder';
  userId: number;
  userLogo: string;
  userPronoun: string | null;
  website: string;
  woman: null;
}

interface ReportProgramDetailsProps {
  programName?: string;
  isThirdParty: boolean;
  organizationUrl?: string;
  organizationName?: string;
  reportStatus?: FeedbackStatus;
}

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .organization-information {
    gap: 21px;
    display: flex;
    align-items: center;
    padding: ${SPACERS.medium};
    .report-program-name {
      .report-program-name-text {
        display: flex;
        gap: ${SPACERS.small};
        align-items: center;
        .report-status {
          font-size: 12px;
          font-weight: normal;
        }
      }
    }
  }
  .powered-by-logo {
    margin-right: ${SPACERS.medium};
  }
`;

const ReportProgramDetails: React.FC<ReportProgramDetailsProps> = ({
  programName,
  organizationUrl,
  organizationName,
  reportStatus,
  isThirdParty,
}) => {
  const { organizationName: orgName, organizationLogo } = useUserActions();
  const org = organizationName || orgName || 'Unknown';
  const logo = organizationUrl || organizationLogo;

  return (
    <StyledDiv>
      <div className="organization-information">
        <RenderOrganizationLogo logo={logo} />
        <div className="report-program-name">
          <TrueImpactText
            variant="heading-subheading"
            className="report-program-name-text"
          >
            {programName || 'Unknown'}{' '}
            {reportStatus && (
              <ReportStatus
                status={reportStatus}
                marginTop={0}
                marginBottom={0}
                hideText={true}
                className="report-status"
              />
            )}
          </TrueImpactText>
          <TrueImpactText>
            <strong>Organization:</strong> {org}
          </TrueImpactText>
        </div>
      </div>
      {isThirdParty && <PoweredByLogo className="powered-by-logo" />}
    </StyledDiv>
  );
};

export default ReportProgramDetails;
